export default __webpack_public_path__ + "static/arrowDropdown-62fc2635956f951a418021fd1189b303.svg";